// Dynamiska headers som sätts vid runtime
// Separerat från API.ts för att undvika cirkulära beroenden med store
const dynamicHeaders = {};
/**
 * Hämta alla dynamiska headers
 */
export function getDynamicHeaders() {
    return dynamicHeaders;
}
/**
 * Sätter workstation-id headern för alla API-anrop
 */
export function setWorkstationId(id) {
    dynamicHeaders['x-workstation-id'] = id != null ? String(id) : '';
}
